import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { LLocalTagContextEnum, LocalTag } from '@winelidays/wld-tsx-2/elements';
import WinePairing from './WinePairing';
const Dish = (t0) => {
    const $ = _c(18);
    const { dish, appendTooltipTo } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== dish.name) {
        t1 = <h4 className=" font-semibold text-gray-500 mr-2 mb-1">{dish.name}</h4>;
        $[0] = dish.name;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    let t2;
    if ($[2] !== appendTooltipTo || $[3] !== dish || $[4] !== translate) {
        t2 = ("isLocal" in dish && dish.isLocal || "isHomeMade" in dish && dish.isHomeMade) &&
            <LocalTag context={LLocalTagContextEnum.dish} appendTooltipTo={appendTooltipTo} translate={translate} linkComponent={Link}/>;
        $[2] = appendTooltipTo;
        $[3] = dish;
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = <div className="flex flex-col md:inline-flex md:flex-row">{t1}{t2}
    </div>;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    let t4;
    if ($[9] !== dish.description) {
        t4 = <p className="text-gray-400 font-semibold text-sm mb-1">{dish.description}</p>;
        $[9] = dish.description;
        $[10] = t4;
    }
    else {
        t4 = $[10];
    }
    let t5;
    if ($[11] !== appendTooltipTo || $[12] !== dish) {
        t5 = "winePairing" in dish && !!dish.winePairing &&
            <WinePairing winePairing={dish.winePairing} appendTooltipTo={appendTooltipTo}/>;
        $[11] = appendTooltipTo;
        $[12] = dish;
        $[13] = t5;
    }
    else {
        t5 = $[13];
    }
    let t6;
    if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = <li className="flex flex-row my-6 first:mt-0 last:mb-3 w-full"><div className="flex-grow flex flex-col items-start">{t3}{t4}{t5}
      </div>
    </li>;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    }
    else {
        t6 = $[17];
    }
    return t6;
};
export default Dish;
